import clone from "clone";
import { Survey, SurveyReport, SurveySegment, SurveyQuestion, SelectionReport, QuestionSummary } from "../../DTOs";
import { QuestionStats } from "./QuestionStats";
import { segmentListIsInLists } from "./segmentationHelpers";
import { surveyReportHelper } from "../..";

export type SurveySegmentFilter = {
    name:string,
    values:string[]
}

export class AggregatedSurveyReport
{
    public data: QuestionStats[];

    constructor(
        survey:Survey,
        surveyReport:SurveyReport,
        public filter:SurveySegment[][]
    ){
        const hits = surveyReport.selectionReports.filter(r => segmentListIsInLists(filter, r.segments));
        this.data = AggregatedSurveyReport.buildData(survey.themes.flatMap(t => t.questions), hits);
    }

    static buildData(questions:SurveyQuestion[], reports:SelectionReport[])
    {
        let combined:QuestionSummary[] = questions.map(q => { return { indicators:clone(q.indicators), selectionSummary:surveyReportHelper.createNewSelectionSummary(), commentCount:0 }});
        
        for(let i=0; i<reports.length; i++){
            const nextSelections = clone(reports[i].questionIndexedSummaries);
            combined = QuestionStats.aggregateLists(combined, nextSelections);
        }
        return combined.map(s => new QuestionStats(s));
    }
}